import { Link } from "react-router-dom";
import { Images } from "../../utils/imageConstants";
import pStore from '../../assets/images/pStore.png';
import aStore from '../../assets/images/aStore.png';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Background Logo */}
      <div className="footer-bg-logo">
        <img src={Images.main_logo} alt="Background Logo" />
      </div>

      <div className="footer-content">
        {/* Top Section: Logo + Brand Name + Description */}
        <div className="footer-top-section">
          <div className="footer-brand">
            <img src={Images.main_logo} alt="Cric Center Logo" className="footer-logo" />
            <h1 className="footer-brand-name">CricCenter</h1>
          </div>
          <p className="footer-description">
            At CricCenter.com, our passion is fueled by a deep understanding that every cricket player, regardless of their skill level, holds the potential to achieve greatness. We're not just an app; we're your dedicated partner in this remarkable journey of self-improvement and cricketing excellence.
          </p>
        </div>

        <div className="footer-top-divider" />

        {/* Middle Section: Company, Contact, App Stores */}
        <div className="footer-middle-section">
          <div className="footer-left-content">
            {/* Company Section */}
            <div className="footer-section">
              <h2 className="footer-section-title">COMPANY</h2>
              <div className="footer-title-underline"></div>
              <div className="footer-links">
                <a href={`${import.meta.env.BASE_URL}#/about`} className="footer-link">About Us</a>
                <a href={`${import.meta.env.BASE_URL}#/careers`} className="footer-link">Careers</a>

              </div>
            </div>

            <div className="footer-vertical-separator" style={{ width: '1px', height: '51px', backgroundColor: '#FFFFFF4A', marginTop: '50px' }}></div>

            {/* Contact Section */}
            <div className="footer-section">
              <h2 className="footer-section-title">CONTACT</h2>
              <div className="footer-title-underline"></div>
              <div className="footer-contact-info">
                {/* <p className="footer-contact-item">+2782 283782</p> */}
                <p className="footer-contact-email">cricccenter.ai@gmail.com</p>
                <div className="footer-social-icons">
                  <a href="#" className="social-icon" aria-label="Facebook">
                    <img src={Images.facebook_icon} alt="Facebook" />
                  </a>
                  <a href="#" className="social-icon" aria-label="Instagram">
                    <img src={Images.insta_icon} alt="Instagram" />
                  </a>
                  <a href="#" className="social-icon" aria-label="Twitter">
                    <img src={Images.twitter_icon} alt="Twitter" />
                  </a>
                  <a href="#" className="social-icon" aria-label="LinkedIn">
                    <img src={Images.linkedin_icon} alt="LinkedIn" />
                  </a>
                </div>

              </div>
            </div>

          </div>
          <div className="footer-section">
            {/* <div className="footer-section-title" style={{}}>DOWNLOAD</div> */}
            <div className="footer-app-stores">
              <a href="https://apps.apple.com/in/app/criccenter/id6475732232" className="app-store-button" aria-label="Download on App Store">
                <img
                  src={aStore}
                  alt="Download on App Store"
                  className="app-store-img"
                />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.hashitlabs.criccenter" className="app-store-button" aria-label="Get it on Google Play">
                <img
                  src={pStore}
                  alt="Get it on Google Play"
                  className="app-store-img"
                />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section: Copyright and Links */}
        <div className="footer-bottom-section-wrapper">
          {/* Divider Line Before Bottom Section */}
          <div className="footer-bottom-divider"></div>

          <div className="footer-bottom-section">
            <p className="footer-copyright">© 2025 CricCenter. All rights reserved.</p>
            <div className="footer-legal-links">
              <Link to="/privacy-policy" className="footer-legal-link">Privacy Policy</Link>
              <span className="footer-legal-separator" />
              <Link to="/terms-of-service" className="footer-legal-link">Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

